// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Unsaved Changes Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  
  width: 95%;
}

.modal-title {
  font-size: 1.125rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: #333;
}

.modal-message {
  margin-bottom: 1rem;
  color: #666;
  line-height: 1.5;
}

.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.btn-save {
  background-color: #0d6efd;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: background-color 0.15s ease-in-out;
}

.btn-save:hover:not(:disabled) {
  background-color: #0b5ed7;
}

.btn-save:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.btn-leave {
  background-color: #dc3545;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: background-color 0.15s ease-in-out;
}

.btn-leave:hover {
  background-color: #c82333;
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .modal-content {
    width: 95%;
    padding: 1rem;
  }
  
  .button-group {
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .btn-save,
  .btn-leave {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/referenes/component/unSaveCmponent.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;;EAExC,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":["/* Unsaved Changes Modal Styles */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 9999;\r\n}\r\n\r\n.modal-content {\r\n  background: white;\r\n  padding: 1.5rem;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  \r\n  width: 95%;\r\n}\r\n\r\n.modal-title {\r\n  font-size: 1.125rem;\r\n  font-weight: bold;\r\n  margin-bottom: 0.5rem;\r\n  color: #333;\r\n}\r\n\r\n.modal-message {\r\n  margin-bottom: 1rem;\r\n  color: #666;\r\n  line-height: 1.5;\r\n}\r\n\r\n.button-group {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 1rem;\r\n}\r\n\r\n.btn-save {\r\n  background-color: #0d6efd;\r\n  color: white;\r\n  padding: 0.5rem 1rem;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.875rem;\r\n  transition: background-color 0.15s ease-in-out;\r\n}\r\n\r\n.btn-save:hover:not(:disabled) {\r\n  background-color: #0b5ed7;\r\n}\r\n\r\n.btn-save:disabled {\r\n  background-color: #6c757d;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.btn-leave {\r\n  background-color: #dc3545;\r\n  color: white;\r\n  padding: 0.5rem 1rem;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.875rem;\r\n  transition: background-color 0.15s ease-in-out;\r\n}\r\n\r\n.btn-leave:hover {\r\n  background-color: #c82333;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 480px) {\r\n  .modal-content {\r\n    width: 95%;\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .button-group {\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .btn-save,\r\n  .btn-leave {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
